import React, { useContext, useEffect, useState } from "react";
import PageTitle from "../../components/PageTitle/PageTitle";
import { Box, Button, Grid, Typography, makeStyles, Paper } from "@material-ui/core";
import ApiConfig from "../../config/ApiConfig";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Axios from "axios";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { UserContext } from "../../context/User";
import CircularProgressWithBackdrop from "../../components/Loader/loader";
const useStyles = makeStyles({
  content: {
    padding: "50px",
    border: "1px solid black",
    background: "white",
  },
  textcontent1: {},
  textcontent: {
    display: "flex",
    flexDirection: "row"
  },
  Image: {
    width: "100%",
    // maxWidth:"59%",
    height: "auto",
  },
  Textfield: {
    fontSize: "20px",
    color: "black",
    marginTop: "17px",
    fontWeight: "500",
  },
  Textfield1: {
    fontSize: "24px",
    fontWeight: "700",
    color: "black",
    marginTop: "17px",
  },

  button: {
    background: "#00d4ff",
    color: "white",
    borderRadius: "10px",
    textTransform: "capitalize",
    fontWeight: "600",
    marginTop: "14px",
  },
  text: {
    fontSize: "14px",
    paddingTop: "16px",

    // diaplay:"flex",
    // flexDirection:"row"
  },
  image: {
    padding: " 10px",
    border: " 1px solid black",
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  textContainer: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
  },
  Textfield2: {
    fontSize: "24px",
    fontWeight: "700",
    color: "black",
    marginTop: "17px",
  },

  "@media (max-width: 960px) and (min-width: 500px)": {
    content: {
      padding: "30px",
    },
    Textfield1: {
      fontSize: "20px",
    },
    Textfield2: {
      fontSize: "20px",
    },
    button: {
      fontSize: "18px",
    },
  },
});

function Viewtestdetails(props) {
  const ContextId = useContext(UserContext);
  const classes = useStyles();
  const [reportDetails, setReportDetails] = useState(null);
  const [reportId, setReportId] = useState(ContextId.id);
  const [uloadedVideo, setUploadedVideo] = useState();
  const [resultVideo, setResultVideo] = useState();
  const [resultImage, setResultImage] = useState();
  const [tutorialVideo, setTutorialVideo] = useState();
  const [loader, setLoader] = useState(false);
  const [unit , setUnit] =  useState(null);
  const history = useHistory();
  const [testIMG, setTestIMG] = useState(null);
  const ViewReportDetails = async () => {
    console.log("Making API request with testId:", reportId);
    setLoader(true);
    try {
      const res = await Axios({
        method: "GET",
        url: ApiConfig.viewTestReportAdmin,
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("id_token")}`,
        },
        params: {
          testId: reportId,
        },
      });
      console.log("response", res)
      if (res.data.status === 200) {
        setReportDetails(res?.data?.data?.testReportData);
        setUnit(res?.data?.data)
        setResultVideo(res?.data?.data?.testReportData?.testResultVideo);
        setResultImage(res?.data?.data?.testReportData?.testResultImage);
        setUploadedVideo(res?.data?.data?.testReportData?.videoUrl);
        setTutorialVideo(res?.data?.data?.tutorialVideo);
        setLoader(false);
        setTestIMG(res?.data?.data?.sampleImage);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };
  useEffect(() => {
    ViewReportDetails();
  }, []);
  return (
    <>
      <PageTitle title="View Test Report Details" />
      {loader ? (
        <CircularProgressWithBackdrop />
      ) : (
        <Grid container justifyContent="center" spacing={3}>
          <Grid item xs={12} md={6}>
            <Paper elevation={3} style={{ padding: 24, marginBottom: 24 }}>
              <Typography variant="h6" gutterBottom style={{ fontWeight: 600 }}>
                Test Information
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={6}><b>Test Name:</b></Grid>
                <Grid item xs={6}>{reportDetails?.testName || "__"}</Grid>
                <Grid item xs={6}><b>Incubation Time:</b></Grid>
                <Grid item xs={6}>{reportDetails?.incubationTime || "__"} {reportDetails?.data}</Grid>
                <Grid item xs={6}><b>Tester Name:</b></Grid>
                <Grid item xs={6}>{reportDetails?.testerName || "__"}</Grid>
                {reportDetails?.location && (
                  <>
                    <Grid item xs={6}><b>Sample Location:</b></Grid>
                    <Grid item xs={6}>{reportDetails.location.split("%")[0] || "__"}</Grid>
                    <Grid item xs={6}><b>Scan Location:</b></Grid>
                    <Grid item xs={6}>{reportDetails.location.split("%")[1] || "__"}</Grid>
                  </>
                )}
                <Grid item xs={6}><b>Approved By:</b></Grid>
                <Grid item xs={6}>{reportDetails?.approvalData?.name || "__"} ({reportDetails?.approvalData?.role || "__"})</Grid>
              </Grid>
            </Paper>
            <Paper elevation={3} style={{ padding: 24, marginBottom: 24 }}>
              <Typography variant="h6" gutterBottom style={{ fontWeight: 600 }}>
                Tutorial Video
              </Typography>
              <Box style={{ textAlign: "center" }}>
                {tutorialVideo ? (
                  <video controls width="100%" height="300px">
                    <source src={tutorialVideo} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  <Typography>Video not found</Typography>
                )}
              </Box>
            </Paper>
            <Paper elevation={3} style={{ padding: 24, marginBottom: 24 }}>
              <Typography variant="h6" gutterBottom style={{ fontWeight: 600 }}>
                Test Sample Image
              </Typography>
              <Box style={{ textAlign: "center" }}>
                {testIMG ? (
                  <img src={testIMG} alt="img" style={{ maxWidth: "100%", maxHeight: 300, borderRadius: 8, border: "1px solid #eee" }} />
                ) : (
                  <Typography>Image not found</Typography>
                )}
              </Box>
            </Paper>
            <Paper elevation={3} style={{ padding: 24, marginBottom: 24 }}>
              <Typography variant="h6" gutterBottom style={{ fontWeight: 600 }}>
                QR Code Details
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={6}><b>Serial No.:</b></Grid>
                <Grid item xs={6}>{reportDetails?.serialNumber || "__"}</Grid>
                <Grid item xs={6}><b>Batch No.:</b></Grid>
                <Grid item xs={6}>{reportDetails?.batchNo || "__"}</Grid>
                <Grid item xs={6}><b>LOT No.:</b></Grid>
                <Grid item xs={6}>{reportDetails?.lotNo || "__"}</Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper elevation={3} style={{ padding: 24, marginBottom: 24 }}>
              <Typography variant="h6" gutterBottom style={{ fontWeight: 600 }}>
                Uploaded Video While Testing
              </Typography>
              <Box style={{ textAlign: "center" }}>
                {uloadedVideo ? (
                  <video controls width="100%" height="300px">
                    <source src={uloadedVideo} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  <Typography>Video not found</Typography>
                )}
              </Box>
            </Paper>
            <Paper elevation={3} style={{ padding: 24, marginBottom: 24 }}>
              <Typography variant="h6" gutterBottom style={{ fontWeight: 600 }}>
                Test Result Video
              </Typography>
              <Box style={{ textAlign: "center" }}>
                {resultVideo ? (
                  <video controls width="100%" height="300px">
                    <source src={resultVideo} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  <Typography>Video not found</Typography>
                )}
              </Box>
            </Paper>
            <Paper elevation={3} style={{ padding: 24, marginBottom: 24 }}>
              <Typography variant="h6" gutterBottom style={{ fontWeight: 600 }}>
                Test Result Image
              </Typography>
              <Box style={{ textAlign: "center" }}>
                {resultImage ? (
                  <img src={resultImage} alt="img" style={{ maxWidth: "100%", maxHeight: 300, borderRadius: 8, border: "1px solid #eee" }} />
                ) : (
                  <Typography>Image not found</Typography>
                )}
              </Box>
            </Paper>
            <Paper elevation={3} style={{ padding: 24, marginBottom: 24 }}>
              <Typography variant="h6" gutterBottom style={{ fontWeight: 600 }}>
                Test Result
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={6}><b>Test Result:</b></Grid>
                <Grid item xs={6}>{reportDetails?.testResult || "--"}</Grid>
                <Grid item xs={6}><b>Test Unit:</b></Grid>
                <Grid item xs={6}>{unit?.unit || "--"}</Grid>
                <Grid item xs={6}><b>Test Status:</b></Grid>
                <Grid item xs={6}>{reportDetails?.testStatus || "--"}</Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      )}
    </>
  );
}

export default Viewtestdetails;
